import { useEffect, useMemo, useState } from "react";
import AxiosInstance, { TokenService } from "../../../../services/Api";
import BlobImage from "../../../../components/BlobImage/BlobImage";
import CustomMRTTable from "../../../../components/CustomMRTTable/CustomMRTTable";
import styles from "../index.module.css";
import { useNavigate } from "react-router-dom";
import { FaPlus, FaPen, FaTrash } from "react-icons/fa";
import { useSelector } from "react-redux";
import PopupModal from "../../../../components/PopupModal/PopupModal";
const ViewHallOfFame = () => {
  const user = TokenService.getUser();
  const clientData = user?.client_data[0] || {};
  const school_id = clientData?.school_id || "";

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  const [searchInput, setSearchInput] = useState("");
  const [apiSearch, setApiSearch] = useState("");

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [selectedId, setSelectedId] = useState(null);
  const [rows, setRows] = useState([]);
  const [modalState, setModalState] = useState({
    open: false,
    type: "success",   // "success" | "error"
    message: "",
    redirectPath: "",
  });
  const navigate = useNavigate();

  const { language, translations } = useSelector((state) => state.language);

  const handleEdit = (data) => {
    if (selectedId) {
      navigate("/user/AddHallOfFame", {
        state: {
          ID: selectedId,
          // DATA: data[1]
        }
      })
    } else {
      alert("Choose any one row!")
    }
  }
  const handleDelete = async (data) => {
    if (selectedId) {
      const payload = {
        id: selectedId
      };
      const response = await AxiosInstance.post(
        `/school/deleteFame`,
        payload
      );
      if (response.data?.status) {
        setModalState({
          open: true,
          type: "success",
          message: response.data?.message,
          redirectPath: "/user/ViewHallOfFame",
        });

      } else {
        setModalState({
          open: true,
          type: "error",
          message: response.data?.message,
          redirectPath: "",
        });
        throw new Error(response.data?.message || "Message send failed");
      }
    } else {
      alert("Choose any one row!")
    }
  }
  const handleCreate = () => {
    navigate("/user/AddHallOfFame")
  }
  // ================= API CALL =================
  const fetchHallOfFame = async () => {
    setLoading(true);

    try {
      const response = await AxiosInstance.post("/school/listFame", {
        school_id,
        search: apiSearch,
        page: pagination.pageIndex + 1,
        limit: pagination.pageSize,
      });
      const mappedRows = response.data.data.map((item) => ({
        id: item.id,
        image: item.image || "",
        name: item.name,
        subject: item.subject,
        content: item.content,
      }));

      setRows(mappedRows);
      setData(response.data?.data || []);
      setRowCount(response.data?.pagination?.total || 0);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {


    fetchHallOfFame();
  }, [pagination.pageIndex, pagination.pageSize, apiSearch]);
  // ================= COLUMNS =================
  const columns = useMemo(() => [
    {
      accessorKey: "image",
      header: translations.labels.image,
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ cell }) => {
        const imagePath = cell.getValue();

        return (
          <BlobImage
            path={imagePath}
            fallback="https://via.placeholder.com/80x80?text=No+Image"
            alt="profile"
            style={{
              width: 80,
              height: 80,
              objectFit: "cover",
              borderRadius: 6,
              border: "1px solid #dcdcdc",
            }}
          />
        );
      },
    },
    {
      accessorKey: "name",
      header: translations.labels.fullname,
      muiFilterTextFieldProps: {
        placeholder: "Filter by Name",
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            setApiSearch(e.target.value);
            setPagination((prev) => ({ ...prev, pageIndex: 0 }));
          }
        },
      },
    },
    {
      accessorKey: "subject",
      header: translations.labels.subject,
      muiFilterTextFieldProps: {
        placeholder: "Filter by Subject",
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            setApiSearch(e.target.value);
            setPagination((prev) => ({ ...prev, pageIndex: 0 }));
          }
        },
      },
    },
    {
      accessorKey: "content",
      header: translations.labels.content,
      muiFilterTextFieldProps: {
        placeholder: "Filter by Content",
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            setApiSearch(e.target.value);
            setPagination((prev) => ({ ...prev, pageIndex: 0 }));
          }
        },
      },
    },
    {
      id: "select",
      header: translations.labels.select,
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <input
          type="radio"
          name="hallOfFameSelect"
          checked={selectedId == row.original.id}
          onChange={() => setSelectedId(row.original.id)}

        />
      ),
    },
  ], [selectedId]);
  const handleSuccessOk = () => {
    const { type, redirectPath } = modalState;
    setModalState((prev) => ({
      ...prev,
      open: false,
    }));
    if (type === "success" && redirectPath) {
      fetchHallOfFame();
      navigate(redirectPath);
    }
  };

  return (
    <>
      <PopupModal
        open={modalState.open}
        title={modalState.type === "success" ? "Success" : "Failed"}
        message={modalState.message}
        onOk={handleSuccessOk}
      />
      <div className={styles.topBar}>
        <div>

        </div>

        <div className={styles.actions}>
          <button className={styles.iconBtn} onClick={handleCreate} ><FaPlus /></button>
          <button className={styles.iconBtn} onClick={() => handleEdit(rows)}><FaPen /></button>
          <button className={styles.iconBtn} onClick={() => handleDelete(rows)}><FaTrash /></button>
        </div>
      </div>
      <CustomMRTTable
        columns={columns}
        data={data}
        placeholder={translations.labels.searchButton}
        loading={loading}
        pagination={pagination}
        rowCount={rowCount}
        onPaginationChange={setPagination}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
        onSearchEnter={(value) => {
          setApiSearch(value);
          setPagination((prev) => ({ ...prev, pageIndex: 0 }));
        }}
      />
    </>

  );
};

export default ViewHallOfFame;